import Decimal from "decimal.js";

/** Spin & Go pools + slot rewards are paid to 2 dp — round DOWN so we never over-distribute. */
const SPIN_AND_GO_PAYOUT_DECIMALS = 2;

/**
 * Spin & Go room pool (daily opt-in, private room) = `collectedUsdt × potFactor`,
 * rounded DOWN to payout precision (2 dp) so the pool never exceeds the drawn factor.
 *
 * @param collectedUsdt The buy-ins the factor resizes (Decimal).
 * @param potFactor     The drawn pot factor (decimal string, e.g. "0.7", "1.5").
 */
export function resolveSpinAndGoPool(collectedUsdt: Decimal, potFactor: string): Decimal {
  return collectedUsdt.mul(potFactor).toDecimalPlaces(SPIN_AND_GO_PAYOUT_DECIMALS, Decimal.ROUND_DOWN);
}

/**
 * Spin & Go duel pool = `stakeUsdt × buyInMultiple` (the per-seat buy-in times the
 * multiple players see), rounded DOWN to 2 dp — ×2 at $10 pays exactly $20.00.
 *
 * @param stakeUsdt     The per-seat buy-in the duel plays at (Decimal).
 * @param buyInMultiple The drawn buy-in multiple (decimal string, e.g. "1.5", "2").
 */
export function resolveSpinAndGoDuelPool(stakeUsdt: Decimal, buyInMultiple: string): Decimal {
  return stakeUsdt.mul(buyInMultiple).toDecimalPlaces(SPIN_AND_GO_PAYOUT_DECIMALS, Decimal.ROUND_DOWN);
}

/**
 * House delta for a Spin & Go competition = `collected − pool`. Positive when the
 * house keeps a spread (factor < 1); negative when Cede subsidised the pool
 * (factor > 1). Used only for analytics — the finalize spread credit floors it at 0.
 */
export function computeSpinAndGoHouseDeltaUsdt(collectedUsdt: Decimal, poolUsdt: Decimal): Decimal {
  return collectedUsdt.minus(poolUsdt);
}
